import React, { useContext, useState, useCallback } from "react";
import { _get_user_from_localStorage } from "../DAL/localstorage/LocalStorage";
import io from "socket.io-client";
import { socketUrl } from "src/config/config";

const CreateContentSetting = React.createContext();
const get_user = _get_user_from_localStorage();
export const useContentSetting = () => useContext(CreateContentSetting);

let socket = {};
socket = io(socketUrl + `?user_id=${get_user?._id}&role=admin`, {
  transports: ["websocket", "polling"],
});

export function ContentSettingState({ children }) {
  const [userInfo, setUserInfo] = useState(get_user);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [userExerciseHistory, setUserExerciseHistory] = useState([]);
  const [userExerciseHistoryLoading, setUserExerciseHistoryLoading] =
    useState(false);
  const [selectedExercise, setSelectedExercise] = useState("");
  const [googleClientId, setGoogleClientId] = useState("");
  const [tinymceKey, setTinymceKey] = useState("");
  const [programTab, setProgramTab] = useState("");
  const [isOpenNotePad, setIsOpenNotePad] = useState(false);
  const [selectedNotepad, setSelectedNotepad] = useState({});
  const [isOpenFormsList, setIsOpenFormsList] = useState(false);
  const [selectedFormsMember, setSelectedFormsMember] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [navbarSubtitle, setNavbarSubtitle] = useState("");
  const [showNavBackButton, setShowNavBackButton] = useState(false);

  const handleSetUserInfo = (val) => {
    setUserInfo(val);
  };

  const handlesetTinyKey = (val) => {
    setTinymceKey(val);
  };

  const handleUnreadMessageCount = (val) => {
    setUnreadMessageCount(val);
  };

  const START_SOCKET_FORCEFULLY = (user_id) => {
    socket = io(socketUrl + `?user_id=${user_id}&role=admin`);
  };

  const STOP_SOCKET_FORCEFULLY = () => {
    socket.disconnect();
  };

  const handleGoogleId = (val) => {
    setGoogleClientId(val);
  };

  const setUserExerciseHistoryCallback = useCallback((val) => {
    setUserExerciseHistory(val);
  }, []);

  const collection = {
    handleSetUserInfo,
    userInfo,
    setUserInfo,
    userExerciseHistory,
    userExerciseHistoryLoading,
    setUserExerciseHistoryLoading,
    selectedExercise,
    setSelectedExercise,
    handleUnreadMessageCount,
    unreadMessageCount,
    setUserExerciseHistory: setUserExerciseHistoryCallback,
    socket,
    START_SOCKET_FORCEFULLY,
    STOP_SOCKET_FORCEFULLY,
    handleGoogleId,
    googleClientId,
    handlesetTinyKey,
    tinymceKey,
    programTab,
    setProgramTab,
    isOpenNotePad,
    setIsOpenNotePad,
    selectedNotepad,
    setSelectedNotepad,
    isOpenFormsList,
    setIsOpenFormsList,
    selectedFormsMember,
    setSelectedFormsMember,
    pageTitle,
    setPageTitle,
    navbarSubtitle,
    setNavbarSubtitle,
    showNavBackButton,
    setShowNavBackButton,
  };
  return (
    <CreateContentSetting.Provider value={collection}>
      {children}
    </CreateContentSetting.Provider>
  );
}
